import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { RequestStatus } from "interfaces/RequestStatus";
import { TaxationKind } from "../../interfaces/TaxationKind";
import { fetchTaxationKindsAPI } from "./fetchTaxationKinds";

interface TaxationKindsState {
  taxationKinds: TaxationKind[];
  status: RequestStatus;
  error: string | null | undefined;
}

const initialState: TaxationKindsState = {
  taxationKinds: [],
  status: RequestStatus.idle,
  error: null,
};

export const getTaxationKinds = createAsyncThunk(
  "taxationKinds/fetchTaxationKinds",
  async (_, { rejectWithValue, getState }) => {
    try {
      const { user } = getState() as RootState;
      const response = await fetchTaxationKindsAPI(user.role);
      return {
        headers: response.headers,
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch taxation kinds");
    }
  }
);

export const taxationKindsSlice = createSlice({
  name: "taxationKinds",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaxationKinds.pending, (state) => {
        state.status = RequestStatus.loading;
        state.error = null;
      })
      .addCase(getTaxationKinds.fulfilled, (state, action) => {
        state.status = RequestStatus.idle;
        state.taxationKinds = action.payload.data.data.taxation_kinds;
      })
      .addCase(getTaxationKinds.rejected, (state, action) => {
        state.status = RequestStatus.failed;
        state.error = action.payload as string; // Error message from rejectWithValue
      });
  },
});

export const selectTaxationKinds = (state: RootState) =>
  state.taxationKinds.taxationKinds;
export const selectTaxationKindsStatus = (state: RootState) =>
  state.taxationKinds.status;
export const selectTaxationKindsError = (state: RootState) =>
  state.taxationKinds.error;

export default taxationKindsSlice.reducer;
